import { I18n } from 'aws-amplify';
import { memo, useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';
import { updatePreviewSettingAtom } from '@/state/atom/chatBotPreview';
import DisplayOptionBySetting from './DisplayOptionBySetting';
import { getOptionDisplayLength } from './handler/ChatBoxHandler';


function ListCategoriesOption({ message, onClickHandler, chatbotSettings,isModePreview, isMaximizedPanel }) {
    const [messageState, setMessagesState] = useState(message)
    useEffect(() => {
        if (message.idMessage !== messageState.idMessage) {
            setMessagesState(message)
        }
    }, [message])
    
    const [maxNumberAnswer, setMaxNumberAnswer] = useState(0);
    const previewSetting = useRecoilValue(updatePreviewSettingAtom);

    useEffect(() => {
        if (!isModePreview) {
            setMaxNumberAnswer(chatbotSettings.maxNumberAnswer);
        }
    }, [chatbotSettings]);

    useEffect(() => {
        if (isModePreview) {
            if (previewSetting.maxNumberAnswer !== maxNumberAnswer) {
                setMaxNumberAnswer(previewSetting.maxNumberAnswer);
            }
        }
    }, [previewSetting]);

    let isShowSeeMore = maxNumberAnswer < messageState?.content?.length;

    return (
        <div className={isMaximizedPanel ? 'message-text  maximized-form-text' : 'message-text'}>
            <div className="text-question">{I18n.get('CBOTMSG001')}</div>
            {messageState?.content?.slice(0, maxNumberAnswer)?.map(option => (
                <div key={`${option.id}-qa`}>
                        <DisplayOptionBySetting 
                            label={option.name}
                            optionDisplayLength={getOptionDisplayLength(chatbotSettings, previewSetting)}
                            onClickHandler={ () => onClickHandler(option, messageState.idMessage)}
                            isMaximizedPanel={isMaximizedPanel}
                        />
                </div>
            ))}
            {isShowSeeMore && (<div className='option-seemore'>{I18n.get('CBOTMSG005')}</div>)}
        </div>
    );
}

export default memo(ListCategoriesOption);
